import { render, staticRenderFns } from "./PeopleTodayProcessLogBarCharttool.vue?vue&type=template&id=67fcf82e"
import script from "./PeopleTodayProcessLogBarCharttool.vue?vue&type=script&lang=js"
export * from "./PeopleTodayProcessLogBarCharttool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports